import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OptionTranslateService } from '../../../../../../shared/services/option-translate.service';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-signatories-list',
  imports: [TranslateModule, FormsModule],
  templateUrl: './signatories-list.component.html',
  styleUrl: './signatories-list.component.scss'
})
export class SignatoriesListComponent {
  @Input() owner: any;
  @Input() memberLabelOwnerPartnerList: any;
  @Input() showAction: boolean = true;
  @Output() onActionClick = new EventEmitter<any>();

  isEditingSignatory: boolean = false;
  // This method is used to initialize the class instance using option translate service
  constructor(
    private optionTranslateService: OptionTranslateService
  ) {

  }

  // This method is used to edit detail using owner
  editDetail(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "edit" })
  }
  viewDetail(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "view" })
  }
  // This method is used to remove using owner
  remove(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "remove" })
  }
  // This method is used to get lookups names using lookup name and key value
  getLookupsNames(lookupName: any, keyValue: any) {
    let nationalities = this.optionTranslateService.getOptions(
      'nationalities', 'en'
    );
    let roles = this.optionTranslateService.getOptions('roles', 'en');

    let masterData: any = lookupName == 'nationalities' ? nationalities : roles;

    if (typeof (keyValue) == 'object' && keyValue) {
      return masterData
        .filter((l: any) => keyValue.includes(l.value))
        .map((l: any) => l.label);
    } else {
      return masterData
        .filter((l: any) => keyValue == l.value)
        .map((l: any) => l.label);
    }
  }

  // This method is used to update owner action using owner
  updateOwnerAction(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "update-action" });
    this.isEditingSignatory = false;
  }

  isNewSignatory(owner: any): boolean {
    if (!this.memberLabelOwnerPartnerList || !owner) {
      owner['isNewSignatory'] = true;
      return true;
    }

    const exists = this.memberLabelOwnerPartnerList.some((item: any) =>
      (item.nameEn && owner.nameEn && item.nameEn === owner.nameEn) ||
      (item.nameAr && owner.nameAr && item.nameAr === owner.nameAr)
    );
    
    owner['isNewSignatory'] = !exists;
    return owner['isNewSignatory'];
  }

  hasMissingRequiredFields(owner: any): boolean {
    if (!owner) {
      return true;
    }

    const hasValue = (value: any): boolean => `${value ?? ''}`.trim() !== '';
    const hasDate = (dateObj: any): boolean =>
      !!dateObj && hasValue(dateObj.day) && hasValue(dateObj.month) && hasValue(dateObj.year);

    const commonRequired =
      hasValue(owner.nameEn) &&
      hasValue(owner.nameAr) &&
      hasValue(owner.nationality) &&
      hasValue(owner.email) &&
      hasValue(owner.mobile) &&
      hasValue(owner.countryCode);

    if (!commonRequired) {
      return true;
    }

    const isUaeResident = (owner.isResident ?? 'No') === 'Yes';
    if (isUaeResident) {
      return !(hasValue(owner.emiratesId) && hasDate(owner.emiratesDob));
    }

    return !(hasValue(owner.passportNumber) && hasDate(owner.passportExpiry));
  }
}
